const Component = {
  "图片 url 不存在": "圖片 url 不存在",
  "暂不支持下载此类型图片": "暫不支持下載此類型圖片",
};

export default Component;
